<script>
import {isString} from '@/js/helpers/type-checkers';

export default {
    name: 'DataLabel',

    functional: true,

    props: {
        item: {type: [String, Object], default: null},
        hideIcon: {type: Boolean},
        iconClass: {type: String, default: null},
        none: {type: String, default: null},
        href: {type: String, default: null},
        hrefInNewWindow: {type: Boolean},
    },

    render(createElement, {props, data, parent, children}) {
        const item = isString(props.item) ? {name: props.item} : props.item;
        const nullLabel = props.none || parent.$t('common.nil');

        const iconElement = props.hideIcon || !props.iconClass
            ? null
            : [createElement('i', {staticClass: props.iconClass + ' fa-fw'}), ' '];

        if (!item) {
            const labelElement = nullLabel === '-'
                ? createElement('span', {domProps: {innerHTML: '&mdash;'}})
                : createElement('em', {staticClass: 'text-muted'}, [nullLabel]);

            return createElement('span', data, [iconElement, labelElement]);
        }

        const nameElement = (item.deleted_at)
            ? createElement('del', {staticClass: 'text-danger', attrs: {title: item.name}}, [item.name])
            : createElement('span', {attrs: {title: item.name}}, [item.name]);

        const labelElement = props.href
            ? createElement('a', {
                attrs: {
                    href: props.href,
                    title: item.name,
                    target: props.hrefInNewWindow ? '_blank' : undefined,
                },
            }, [nameElement])
            : nameElement;

        return createElement('span', data, [iconElement, labelElement].concat(children));
    },
};
</script>
